(function()
{
	var Application = include('springroll.Application');
	var Debug = include('springroll.Debug', false);
	var Polygon = include('collision.Polygon');
	var Sprite = include('PIXI.Sprite');
	var UnitContainer = include('nature.UnitContainer');

	/**
	 * Any object in the world
	 * @class Floater
	 * @extends nature.UnitContainer
	 * @constructor
	 * @param {Object} config the config for our type, i.e., the contents of bird.json
	 * @param {Object} [json]  the parameters for our instance from a level segment json
	 */
	var Floater = function(config, json, type)
	{
		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;

		this.type = type;

		UnitContainer.call(this, null, config);

		this.animated = !!config.animated;
		this.anim = config.anim || null;
		this.isPowerup = !!config.powerup;

		// Is this the frisbee, the bubble, etc.
		this.isPowerupSegment = !!config.powerupSegment;

		this.powerupData = config.powerup || null;
		this.collision = new Polygon(config.collision);
		this.sfx = config.sfx || null;

		var art;
		if (config.art)
		{
			var ArtClass = this.ArtClass = include(config.art);
			if (this.animated)
			{
				art = new ArtClass();
				art.framerate = 30;
				art.stop();

				// ~szk: HACK we only have one floater at the point of creating this
				// stop, so I'm doing anything to externalize this
				if (art.bubble)
				{
					art.bubble.stop();
				}
			}
			else
			{
				art = new Sprite(ArtClass);
				art.anchor.x = 0.5;
				art.anchor.y = 0.5;
			}
		}
		else if (config.clip)
		{
			art = this.app.getCache(config.clip);
		}

		this.addChildAt(art, 0);
		this.art = art;

		// Save methods as own property instead of prototype property, for better
		// speed when we are calling it a ton
		this.move = this.move;
		this.start = this.start;
		this.collide = this.collide;

		if (json)
		{
			this.init(json);
		}
	};

	var DEG_TO_RAD = Math.PI / 180;

	var s = UnitContainer.prototype;
	var p = extend(Floater, UnitContainer);

	/**
	 * Initialize if the floater is being recycled
	 * @method init
	 * @param {Object} [json] The configuration override
	 */
	p.init = function(json)
	{
		this.additionalSpeed = json.additionalSpeed || this.config.additionalSpeed || 0;
		if (this.additionalSpeed)
		{
			this.additionalSpeed.x = this.additionalSpeed.x || 0;
			this.additionalSpeed.y = this.additionalSpeed.y || 0;
			this.additionalSpeed.rotation = this.additionalSpeed.rotation || 0;
		}
		this.visible = true;
		this.bounds = this.getBounds();
		this.boundsWidth = this.bounds.width;
	};

	/**
	 * Start playing on the screen
	 * @method start
	 */
	p.start = function()
	{
		if (this.animated)
		{
			if (this.anim)
			{
				this.app.animator.play(this.art, this.anim);
			}
			else
			{
				this.art.gotoAndPlay(0);
			}
		}
		// In pixel coordinates, positive numbers are further along
		this.startX = this.x;
		this.collision.updateOrigin(this.x, this.y);
		this.visible = true;
		if (this.art.item)
			this.art.item.visible = true;
		if (this.art.sparkleFX)
			this.art.sparkleFX.visible = true;
		this.enabled = true;
		if (this.sfx)
		{
			this._soundInstance = this.app.sound.play(this.sfx,
			{
				loop: true
			});
		}
	};

	/**
	 * Check to see that the floater is still active (on-screen)
	 * @method isActive
	 * @param {Number} viewportLeft The left edge of the camera's view of the world
	 * @return {Boolean} If the floater is on-screen still
	 */
	p.isActive = function(viewportLeft)
	{
		if (!this.art)
		{
			return false;
		}
		// Assume all floaters have their art centered
		return (this.x + this.boundsWidth) > viewportLeft;
	};

	/**
	 * Clear/reset the art
	 * @method reset
	 */
	p.reset = function()
	{
		if (this.animated && this.art)
		{
			if (this.anim)
			{
				this.app.animator.stop(this.art);
			}
			else
			{
				this.art.stop();
			}
		}

		this.enabled = false;
		// this.visible = true;

		if (this._soundInstance)
		{
			this.app.sound.fadeOut(this._soundInstance);
		}
		this._soundInstance = null;

		this.scale.x = 1;
		this.scale.y = 1;
	};

	/**
	 * Move method called every frame
	 * @method move
	 * @param {int} delta The change in time
	 * @param {Number} pixelDistance How far we've traveled
	 */
	p.move = function(delta, pixelDistance, viewportLeft, viewportRight)
	{
		if (this.additionalSpeed && this.visible)
		{
			//additionalSpeed is an object with x and y OR a 'method' property
			var deltaX = this.additionalSpeed.x * delta;
			var deltaY = this.additionalSpeed.y * delta;
			var rotation = this.additionalSpeed.rotation * DEG_TO_RAD * delta;

			if (this.additionalSpeed.algo)
			{
				// For some math guidance refer to http://jwilson.coe.uga.edu/EMAT6680Fa07/O'Kelley/Assignment%201/Transformations.html
				var amplitude = this.additionalSpeed.amplitude || 1;
				var period = this.additionalSpeed.period || 1;
				var distance = this.additionalSpeed.useLocal === true ? (pixelDistance - this.startX) : pixelDistance;
				deltaY = delta * amplitude * Math.sin(period * distance);
			}

			this.rotation += rotation;
			this.x += deltaX;
			this.y += deltaY;
			this.collision.updateOrigin(
				this.collision.origin.x + deltaX,
				this.collision.origin.y + deltaY
			);
		}

		if (this.x + this.boundsWidth < viewportLeft)
			this.visible = false;
		else if (this.x - this.boundsWidth > viewportRight)
			this.visible = false;
		else
			this.visible = true;
	};

	/**
	 * Collided with a seed
	 * @method collide
	 */
	p.collide = function()
	{
		this.enabled = false;
		var vo = this.config.vo;
		var player = this.app.voPlayer;

		// Don't play if we're already playing a sound
		if (!this.app.isTutorial && vo && !player.playing && this.config.voChance < Math.random())
		{
			player.play(vo);
		}

		//Award the flyIntoBird badge if not already received
		if (!this.app.flyIntoBird)
		{
			//Is this item one of the birds?  
			switch (this.type)
			{
				case 'bluejay':
				case 'cardinal':
				case 'chickadee':
				case 'crow':
				case 'robin':
					//send signal to site about receiving flyIntoBird badge
					app.container.send('badgeEvent', 'fiveHundredFeet');
					this.app.flyIntoBird = true;
					break;
			}
		}
	};

	/**
	 * Destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		s.destroy.call(this);

		if (this.animated)
		{
			if (this.anim)
			{
				this.app.animator.stop(this.art);
			}
			else
			{
				this.art.stop();
			}
		}

		if (this.sfx)
		{
			this.app.sound.stop(this.sfx);
		}

		this.additionalSpeed = null;
		this.anim = null;
		this.animated = null;
		this.art = null;
		this.collide = null;
		this.collision = null;
		this.isPowerup = null;
		this.move = null;
		this.powerupData = null;
		this.start = null;
		this.startX = null;
		this._soundInstance = null;
	};

	namespace('nature').Floater = Floater;

}());